/**
 * These enums are just helpers used in forms, all definition of enums is in localization
 */

import { i18n } from "@/locales/setup.js"
const locale = window.localStorage["covergo-locale"] || "en-US"

// All possible countries
const countries = Object.keys(i18n.messages[locale].countries).map(key => ({
	name: i18n.messages[locale].countries[key],
	value: key
}))

// Payment frequency
const paymentFrequency = Object.keys(
	i18n.messages[locale].payment_frequency_enums
).map(key => ({
	name: i18n.messages[locale].payment_frequency_enums[key],
	value: key
}))

const paymentMethods = Object.keys(
	i18n.messages[locale].payment_methods_enums
).map(key => ({
	name: i18n.messages[locale].payment_methods_enums[key],
	value: key
}))

const currencies = Object.keys(i18n.messages[locale].currencies).map(key => ({
	name: i18n.messages[locale].currencies[key],
	value: key
}))

const sources = Object.keys(i18n.messages[locale].sources).map(key => ({
	name: i18n.messages[locale].sources[key],
	value: key
}))

const contactTypes = Object.keys(i18n.messages[locale].contact_type_enums).map(
	key => ({
		name: i18n.messages[locale].contact_type_enums[key],
		value: key
	})
)

const identityTypes = Object.keys(
	i18n.messages[locale].identity_type_enums
).map(key => ({
	name: i18n.messages[locale].identity_type_enums[key],
	value: key
}))

const salutationTypes = Object.keys(
	i18n.messages[locale].salutation_type_enums
).map(key => ({
	name: i18n.messages[locale].salutation_type_enums[key],
	value: key
}))

const genderTypes = Object.keys(i18n.messages[locale].gender_type_enums).map(
	key => ({
		name: i18n.messages[locale].gender_type_enums[key],
		value: key
	})
)

const maritalStatusTypes = Object.keys(
	i18n.messages[locale].marital_status_enums
).map(key => ({
	name: i18n.messages[locale].marital_status_enums[key],
	value: key
}))

export {
	countries,
	paymentFrequency,
	sources,
	currencies,
	paymentMethods,
	contactTypes,
	identityTypes,
	salutationTypes,
	genderTypes,
	maritalStatusTypes
}
